export default __webpack_public_path__ + "static/media/photo--lg--namrata-3.c92454c8.jpg";